export default __webpack_public_path__ + "static/media/Yes mam.e2c02875.mp3";